import { render, staticRenderFns } from "./LogsCard.vue?vue&type=template&id=1ea0c2e9&scoped=true&lang=pug&"
import script from "./LogsCard.vue?vue&type=script&lang=ts&"
export * from "./LogsCard.vue?vue&type=script&lang=ts&"
import style0 from "./LogsCard.vue?vue&type=style&index=0&id=1ea0c2e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea0c2e9",
  null
  
)

export default component.exports